module.exports = __webpack_public_path__ + "img/215-Schoco SAF-DB703.png";